<template>
    <div id="search_filter" data-simplebar>
        <div>
            <property-type-filter @filter="filterResults" />
            <district-filter @filter="filterResults" />
            <rent-price-filter @filter="filterResults" />
            <bedrooms-filter @filter="filterResults" />
            <bathrooms-filter @filter="filterResults" />
            <amenity-filter @filter="filterResults" />
        </div>
        <!-- <breadcrumbs @filter="filterResults" /> -->
    </div>
</template>

<script>
import PropertyTypeFilter from './filters/property_type.vue';
import DistrictFilter from './filters/district.vue';
import RentPriceFilter from './filters/rent_price.vue';
import Breadcrumbs from './filters/breadcrumbs.vue';
import AmenityFilter from './filters/amenity.vue';
import BedroomsFilter from './filters/bedrooms.vue';
import BathroomsFilter from './filters/bathrooms.vue';

export default {
    components: {
        PropertyTypeFilter,
        DistrictFilter,
        RentPriceFilter,
        Breadcrumbs,
        AmenityFilter,
        BedroomsFilter,
        BathroomsFilter
    },
    methods: {
        filterResults() {
            this.$emit('filterResults');
        }
    }
}
</script>
